import React from "react";
import { useLocation, Link } from "react-router-dom";
import { useSelector } from "react-redux";
import "./Style.css";

function Error() {
  const location = useLocation();
  const { authorization } = useSelector((state) => state.localStorage);
  const isLoggedIn = authorization.auth;

  // 현재 경로가 권한이 필요한 페이지인지 확인
  const privatePages = ["/selected-company", "/selected-site", "/composed-education", "/watch-education", "/health-interview", "/health-document", "/construction-test", "/my-calendar"];

  const publicOnlyPages = ["/login", "/signup"];

  const currentPath = location.pathname;
  const isPrivatePage = privatePages.includes(currentPath);
  const isPublicOnlyPage = publicOnlyPages.includes(currentPath);

  // 에러 메시지 결정
  let errorTitle = "Oops! Page not found.";
  let errorMessage = "The page you are looking for does not exist.";
  let actionText = "Go Back";
  let actionLink = "/";

  if (isPrivatePage && !isLoggedIn) {
    errorTitle = "접근 권한이 없습니다.";
    errorMessage = "이 페이지에 접근하려면 로그인이 필요합니다.";
    actionText = "로그인하기";
    actionLink = "/login";
  } else if (isPublicOnlyPage && isLoggedIn) {
    errorTitle = "이미 로그인되어 있습니다.";
    errorMessage = "로그인된 상태에서는 이 페이지에 접근할 수 없습니다.";
    actionText = "메인으로 이동";
    actionLink = "/";
  }

  return (
    <section className='crancy-error'>
      <div className='crancy-error__content'>
        <h2 className='crancy-error__title'>{errorTitle}</h2>
        <p className='crancy-error__message'>{errorMessage}</p>
        <Link to={actionLink} className='crancy-btn crancy-btn--error'>
          {actionText}
        </Link>
      </div>
    </section>
  );
}

export default Error;
